var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 56,
    height: 56,
    rx: 4,
    fill: "#FF7E84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 24C36.8807 24 38 22.8807 38 21.5C38 20.1193 36.8807 19 35.5 19C34.1193 19 33 20.1193 33 21.5C33 22.8807 34.1193 24 35.5 24Z",
    fill: "#FF7E84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 24C36.8807 24 38 22.8807 38 21.5C38 20.1193 36.8807 19 35.5 19C34.1193 19 33 20.1193 33 21.5C33 22.8807 34.1193 24 35.5 24Z",
    fill: "#FF7E84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.72 25.31C36.02 25.53 35.25 25.57 34.45 25.37C33.11 25.02 32.02 23.95 31.65 22.61C31.47 21.96 31.46 21.32 31.57 20.74C31.7 20.1 31.25 19.5 30.61 19.5H23C20 19.5 18 21 18 24.5V31.5C18 35 20 36.5 23 36.5H33C36 36.5 38 35 38 31.5V26.26C38 25.6 37.36 25.1 36.72 25.31ZM31.52 27.15L30.34 28.09C29.68 28.62 28.84 28.88 28 28.88C27.16 28.88 26.31 28.62 25.66 28.09L22.53 25.59C22.21 25.33 22.16 24.85 22.41 24.53C22.67 24.21 23.14 24.15 23.46 24.41L26.59 26.91C27.35 27.52 28.64 27.52 29.4 26.91L30.58 25.97C30.9 25.71 31.38 25.76 31.63 26.09C31.89 26.41 31.84 26.89 31.52 27.15Z",
    fill: "#FF7E84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.17a0df91a8dcae2b856bf91e18c6f978.svg";
export { ForwardRef as ReactComponent };